import { usePermissions } from '@/hooks/usePermissions'
import ForbiddenPage from '@/pages/ForbiddenPage'

interface PermissionRouteProps {
  /** Single permission or array of permissions (OR logic: any one is sufficient) */
  permission: string | string[]
  children: React.ReactNode
}

const PermissionRoute = ({ permission, children }: PermissionRouteProps) => {
  const { hasPermission, loading } = usePermissions()

  if (loading) return null

  const permissions = Array.isArray(permission) ? permission : [permission]
  const allowed = permissions.some(p => hasPermission(p))

  if (!allowed) {
    return <ForbiddenPage />
  }

  return <>{children}</>
}

export default PermissionRoute
